$(function () {
	$('.box-input.inline-label').on('input', onInput);
});

$(document).on("mvvm:updated", function () {
	$('.box-input.inline-label').off('input', onInput);
	$('.box-input.inline-label').on('input', onInput);
});

function onInput() {
	onInputChanged($(this));
}

function onInputChanged($container) {
	const $input = $container.children('.input');
	const $textarea = $input.children('textarea');
	let val = null;
	// console.log("Value: " + input.val());
	if ($textarea.length > 0) {
		const editor = $textarea.prop('data-froala.editor');
		val = editor.html.get();
	} else {
		val = $input.val();
	}

	if (val != "") {
		$container.addClass('has-value');
	} else {
		$container.removeClass('has-value');
	}
}

function checkPasswordComplexity(value, targetCssElement, checkLength, checkCase, checkNumbers, checkSymbols) {
	$(targetCssElement).removeClass("weak");
	$(targetCssElement).removeClass("strong");

	if (!value || value.length === 0)
		return;

	var hasMinLength = value != null && value.length >= 8;
	var hasLowercase = /[a-z]/.test(value);
	var hasUppercase = /[A-Z]/.test(value);
	var hasNumbers = /[0-9]/.test(value);
	var hasNonWord = /\W/.test(value);

	var lengthOk = true;
	var caseOk = true;
	var numbersOk = true;
	var symbolsOk = true;
	if (checkLength) {
		lengthOk = hasMinLength;
	}
	if (checkCase) {
		caseOk = hasLowercase && hasUppercase;
	}
	if (checkNumbers) {
		numbersOk = hasNumbers;
	}
	if (checkSymbols) {
		symbolsOk = hasNonWord;
	}

	if (lengthOk && caseOk && numbersOk && symbolsOk)
		$(targetCssElement).addClass("strong");
	else
		$(targetCssElement).addClass("weak");
}

function changeInputType(input) {
	let passwordInput;
	let toggleButton;

	if (typeof input === 'string') {
		// If input is a string (ID), get the element
		passwordInput = document.getElementById(input);
		toggleButton = passwordInput.parentElement.querySelector('.toggle-password');
	} else if (input instanceof HTMLElement) {
		// If input is already an HTML element (the button itself)
		toggleButton = input;
		passwordInput = toggleButton.previousElementSibling;
	} else {
		console.error('Invalid input type for changeInputType function');
		return;
	}

	if (passwordInput && toggleButton) {
		const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
		passwordInput.setAttribute('type', type);

		// Toggle the eye icon
		const icon = toggleButton.querySelector('i');
		icon.classList.toggle('fa-eye');
		icon.classList.toggle('fa-eye-slash');
	}
}